export default __webpack_public_path__ + "static/media/whiteBtn.97dc8f63.svg";